import { ColumnsType } from "antd/es/table";
import { Space, Dropdown } from "antd";
import ColumnSearch from "./ColumnSearch"; // Seu componente de busca
import { BotoesAcoes } from "../styles"; // Botões de ação
import SettingsIcon from "@mui/icons-material/Settings";
import { getMenuItems } from "../constants/itemsActionColumns";

export const Columns = (
  onClick: (e: any) => void,
  selecionarApartamento: (row: any) => void,
  filteredInfo: {
    empreend?: string[] | null;
    nomeAp?: string[] | null;
    origemAp?: string[] | null;
  }
): ColumnsType<any> => {
  const items = getMenuItems();

  return [
    {
      title: "Empreendimento",
      dataIndex: "empreendimento",
      key: "empreendimento",
      width: "28%",
      ellipsis: true,
      filteredValue: filteredInfo.empreend || null, // Aplicar os valores do estado
      onFilter: (value, record) => record.empreendimento.includes(value),
      ...ColumnSearch<any>({ dataIndex: "empreendimento" }),
    },
    {
      title: "Apartamento",
      dataIndex: "nome",
      key: "nome",
      width: "24%",
      ellipsis: true,
      filteredValue: filteredInfo.nomeAp || null, // Aplicar os valores do estado
      onFilter: (value, record) => record.apartamento.includes(value),
      ...ColumnSearch<any>({ dataIndex: "nome" }),
    },
    {
      title: "Cotas Usuários",
      dataIndex: "cotasUsuarios",
      key: "cotasUsuarios",
      width: "14%",
      render: (value) => value ?? 0,
    },
    {
      title: "Origem",
      dataIndex: "origem",
      key: "origem",
      width: "14%",
      ellipsis: true,
      filters: [
        { text: "Multicotas", value: "Multicotas" },
        { text: "Usuário", value: "Usuário" },
      ],
      filteredValue: filteredInfo.origemAp || null,
      onFilter: (value, record) => record.origem.includes(value),
      filterSearch: true,
    },

    {
      title: "Ações",
      dataIndex: "operation",
      key: "operation",
      width: "8%",
      align: "center",
      filteredValue: null,
      render: (item, row) => (
        <Space size="middle">
          <Dropdown menu={{ items, onClick }} trigger={["click"]}>
            <BotoesAcoes
              type="button"
              onClick={() => {
                selecionarApartamento(row);
              }}
            >
              <SettingsIcon />
            </BotoesAcoes>
          </Dropdown>
        </Space>
      ),
    },
  ];
};
